<div class="audience-selector" [class.disabled]="isDisabled">
  <div class="dropdown-trigger" [class.detailed]="isReachInTrigger()" (click)="toggleDropdown()">
    <div class="dropdown-trigger-body">
      <div class="dropdown-trigger-main">
        <span class="dropdown-trigger-value">{{ selectedItem() ? (selectedItem()!.name | translate) : placeholder }}</span>
        @if (editEnabled && selectedItem()) {
          <mat-icon
            class="dropdown-trigger-edit"
            role="button"
            tabindex="0"
            [attr.aria-label]="'generic.edit' | translate"
            [matTooltip]="'generic.edit' | translate"
            (click)="onEdit($event)"
            (keydown.enter)="onEdit($event)"
            (keydown.space)="onEdit($event)"
            data-test="audience-selector-edit">
            edit
          </mat-icon>
        }
      </div>
      @if (isReachInTrigger() && triggerReach(); as reach) {
        <div
          class="dropdown-trigger-reach"
          [matTooltip]="reach.tooltipKey ?? '' | translate"
          [matTooltipDisabled]="!reach.tooltipKey"
          matTooltipShowDelay="350"
          data-test="audience-selector-trigger-reach">
          <ng-container *ngTemplateOutlet="reachText; context: { $implicit: reach }"></ng-container>
        </div>
      }
    </div>
    <mat-icon class="dropdown-trigger-arrow" [class.open]="isOpen">keyboard_arrow_down</mat-icon>
  </div>

  @if (isOpen) {
    <div class="dropdown-backdrop" (click)="closeDropdown()"></div>
    <div class="dropdown-panel">
      <ng-container *ngTemplateOutlet="panelContent"></ng-container>
    </div>
  }
</div>

<ng-template #reachText let-reach>
  {{ "campaign.widget.estimated-reach" | translate }}:
  @switch (reach.state) {
    @case ("loading") {
      {{ "audience.statistics.calculating" | translate }}
    }
    @case ("na") {
      {{ "generic.not-available" | translate }}
    }
    @default {
      {{ reach.prefix }}{{ reach.value | toLocaleNumber }}
      @if (reach.qualifier; as qualifier) {
        · {{ qualifier.key | translate: qualifier.params }}
      }
    }
  }
</ng-template>

<ng-template #panelContent>
  <div class="dropdown-search">
    <mat-icon class="dropdown-search-icon">search</mat-icon>
    <input
      #searchInput
      type="text"
      class="dropdown-search-input"
      [value]="searchQuery()"
      (input)="searchQuery.set($any($event.target).value)"
      [placeholder]="'response-lists.search-placeholder' | translate"
      (click)="$event.stopPropagation()" />
  </div>
  <div class="dropdown-sort-bar">
    <div class="dropdown-sort-buttons">
      <span class="dropdown-sort-label">{{ "response-lists.sort-by" | translate }}:</span>
      <button type="button" class="dropdown-sort-btn active" (click)="toggleSort()">
        {{ "audience.sort.activity" | translate }}
        <mat-icon class="dropdown-sort-icon">{{ sortIcon() }}</mat-icon>
      </button>
    </div>
    @if (showCreateNew) {
      <button
        mat-stroked-button
        class="create-new-btn"
        [disabled]="disableCreateNew"
        [matTooltip]="createNewTooltip"
        [matTooltipDisabled]="!disableCreateNew"
        (click)="onCreateNew($event)">
        <mat-icon>add</mat-icon>
        <span>{{ "campaign.widget.audience.create-new" | translate | uppercase }}</span>
      </button>
    }
  </div>
  <div class="dropdown-list">
    @for (item of itemViews(); track item.audience.id) {
      <div
        class="dropdown-item"
        [class.selected]="selectedItem()?.id === item.audience.id"
        [class.disabled]="item.isDisabled"
        [matTooltip]="sessionConditionTooltip"
        [matTooltipDisabled]="!item.isDisabled"
        (click)="selectItem(item.audience)">
        <span class="dropdown-item-name">{{ item.audience.name | translate }}</span>
        <span
          class="dropdown-item-meta"
          [matTooltip]="item.reach.tooltipKey ?? '' | translate"
          [matTooltipDisabled]="item.isDisabled || !item.reach.tooltipKey"
          matTooltipShowDelay="350"
          data-test="audience-selector-item-reach">
          <ng-container *ngTemplateOutlet="reachText; context: { $implicit: item.reach }"></ng-container>
        </span>
      </div>
    }
    @if (itemViews().length === 0) {
      <div class="dropdown-empty">{{ "response-lists.no-matching" | translate }}</div>
    }
  </div>
</ng-template>
